import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-new-review-upload-image',
  templateUrl: './new-review-upload-image.component.html',
  styleUrls: ['./new-review-upload-image.component.scss']
})
export class NewReviewUploadImageComponent implements OnInit {

  uploadStatus: string = "default";
  uploadReviewImageFG: FormGroup;
  submitted = false;
  reviewGoogleId: any = "";
  manual_type: any = "";
  reviewGooglePhoneNumber: any = "";
  showPage: number = 1;
  img: File;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router
  ) { 
    // this.reviewGoogleId = this.route.snapshot.paramMap.get('id');
    const id = this.route.snapshot.queryParams['id'];
    const phone = this.route.snapshot.queryParams['phone'];
    const manual_type = this.route.snapshot.queryParams['manual_type'];
    console.log(id,'---id---', phone, '---phone---', manual_type,'---manual_type---');
    this.reviewGoogleId = atob(id);
    this.reviewGooglePhoneNumber = atob(phone);
    this.manual_type = atob(manual_type);
    
    if(this.manual_type == 1){
      this.getGoogleReviewDetail(this.reviewGoogleId)
    }
    
    if(this.manual_type == 2){
      this.getGoogleReviewDetail_2(this.reviewGoogleId)
    }
    
    if(this.manual_type == 3){
      this.getGoogleReviewDetail_3(this.reviewGoogleId)
    }
    
    /* route.params.subscribe(val => {
      console.log(val,'---val----');
      this.reviewGoogleId = atob(val.id);
      this.reviewGooglePhoneNumber = atob(val.phone);
      console.log(this.reviewGoogleId,'---this.reviewGoogleId----');
      console.log(this.reviewGooglePhoneNumber,'---this.reviewGooglePhoneNumber---');
      this.getGoogleReviewDetail(this.reviewGoogleId)
    }); */
  
  }

  fileName = '';
  ngOnInit(): void {
    // this.getGoogleReviewDetail(this.reviewGoogleId)
    this.uploadReviewImageFG = this.formBuilder.group({
      imageInput: [this.fileName, Validators.required]
      // remark: ["", [Validators.required]],
      // subadminid: ["", [Validators.required]],
    })
  }

  get uploadReviewImageFG_v() { return this.uploadReviewImageFG.controls };

  getGoogleReviewDetail(id){
    this.auth.get_feedback_subadmin_google_detail(id).subscribe(
      (response: any) => {
       console.log(response.body,'----response---')
       const currentTime = Math.round(new Date().getTime() / 1000)
       const responseData = response.body
       if(responseData == null){
        this.uploadStatus = 'null'
        return
       }
       const reviewCreateTime = responseData.link_created_time
       const diffTime = currentTime - reviewCreateTime
       const expiryTime = 86400 * 3;
       if(responseData?.last_feedback_message_id == null){
        this.uploadStatus = 'not_sent'
       }else if(this.reviewGooglePhoneNumber != responseData?.last_feedback_message?.phone){
        this.uploadStatus = 'user_expired'
       }else if(responseData.is_file_uploaded == 1){
        this.uploadStatus = 'success'
       } else if(diffTime > expiryTime){
         this.uploadStatus = 'expired'
       } else {
        this.uploadStatus = 'default'
       }
       return responseData;
      },
      (error) => {
        console.log(error,'----error---')
        this.uploadStatus = 'error'
      }
    );
  }

  getGoogleReviewDetail_2(id){
    this.auth.get_feedback_subadmin_google_detail_2(id).subscribe(
      (response: any) => {
       console.log(response.body,'----response---')
       const currentTime = Math.round(new Date().getTime() / 1000)
       const responseData = response.body
       if(responseData == null){
        this.uploadStatus = 'null'
        return
       }
       const reviewCreateTime = responseData.link_created_time
       const diffTime = currentTime - reviewCreateTime
       const expiryTime = 86400 * 3;
       if(responseData?.last_feedback_message_id == null){
        this.uploadStatus = 'not_sent'
       }else if(this.reviewGooglePhoneNumber != responseData?.last_feedback_message?.phone){
        this.uploadStatus = 'user_expired'
       }else if(responseData.is_file_uploaded == 1){
        this.uploadStatus = 'success'
       } else if(diffTime > expiryTime){
         this.uploadStatus = 'expired'
       } else {
        this.uploadStatus = 'default'
       }
       return responseData;
      },
      (error) => {
        console.log(error,'----error---')
        this.uploadStatus = 'error'
      }
    );
  }

  getGoogleReviewDetail_3(id){
    this.auth.get_feedback_subadmin_google_detail_3(id).subscribe(
      (response: any) => {
       console.log(response.body,'----response---')
       const currentTime = Math.round(new Date().getTime() / 1000)
       const responseData = response.body
       if(responseData == null){
        this.uploadStatus = 'null'
        return
       }
       const reviewCreateTime = responseData.link_created_time
       const diffTime = currentTime - reviewCreateTime
       const expiryTime = 86400 * 3;
       if(responseData?.last_feedback_message_id == null){
        this.uploadStatus = 'not_sent'
       }else if(this.reviewGooglePhoneNumber != responseData?.last_feedback_message?.phone){
        this.uploadStatus = 'user_expired'
       }else if(responseData.is_file_uploaded == 1){
        this.uploadStatus = 'success'
       } else if(diffTime > expiryTime){
         this.uploadStatus = 'expired'
       } else {
        this.uploadStatus = 'default'
       }
       return responseData;
      },
      (error) => {
        console.log(error,'----error---')
        this.uploadStatus = 'error'
      }
    );
  }

  onFileChanged(event) {
    this.img = event.target.files[0];
    this.uploadReviewImageFG.controls['imageInput'].setValue(this.img ? this.img.name : '');
  }

  uploadImageData() {
    this.submitted = true;
    if (this.uploadReviewImageFG.invalid) {
      return false;
    }

    const formData = new FormData()
    formData.append("image", this.img)
    formData.append("subadminid", '0')
    formData.append("remark", "")
    formData.append("saveSubadnminid", this.reviewGoogleId)
    formData.append("is_upload_by_user", '1')
    formData.append("user_phone", this.reviewGooglePhoneNumber)

    if(this.manual_type == 1){
      this.auth.reviewImageUploadForm(formData).subscribe(
        (response: any) => {
          this.uploadStatus = 'success';
        },
        (error) => {
          if (error.status == 401) {
            this.local.logout();
            this.router.navigate(['/admin']);
          }
        }
      );
    }
    
    if(this.manual_type == 2){
      this.auth.reviewImageUploadForm_2(formData).subscribe(
        (response: any) => {
          this.uploadStatus = 'success';
        },
        (error) => {
          if (error.status == 401) {
            this.local.logout();
            this.router.navigate(['/admin']);
          }
        }
      );
    }
    
    if(this.manual_type == 3){
      this.auth.reviewImageUploadForm_3(formData).subscribe(
        (response: any) => {
          this.uploadStatus = 'success';
        },
        (error) => {
          if (error.status == 401) {
            this.local.logout();
            this.router.navigate(['/admin']);
          }
        }
      );
    }

    // this.verify_review(this.saveSubadnminid)
    // this.modalService.dismissAll();
  }

}
